import {View} from "@lernetz/ts-lib";
import {observeArray} from "@lernetz/ts-lib/src/Observer";
import template from "./list.view.html";
import toolTemplate from "./cards/tool.template.html";
import gpTemplate from "./cards/good-practice.template.html";
import {languageService} from "../../../services/lang";

export class ToolListView extends View {
    constructor() {
        super({ template })
        this.registry.add('App\\Tool', () => new View({template: toolTemplate}));
        this.registry.add('App\\GoodPractice', () => new View({template: gpTemplate}));
    }
    init() {
        observeArray(this.data.tools);
        this.data.lang = languageService.currentLang
    }
}
